export const playlistTypes = {
  ADD_COMMENT_TO_SAVED_ITEMS: 'playlist_add_comment_to_saved_items',
  ADD_COMMENT_TO_SCRATCHPAD: 'playlist_add_comment_to_scratchpad',
  ADD_TRACK_TO_SAVED_ITEMS: 'playlist_add_track_to_saved_items',
  ADD_TRACK_TO_SCRATCHPAD: 'playlist_add_track_to_scratchpad',
  ADD_TRAFFIC_TO_SAVED_ITEMS: 'playlist_add_traffic_to_saved_items',
  ADD_VOICE_BREAK_TO_SAVED_ITEMS: 'playlist_add_voice_break_to_saved_items',
  ADD_VOICE_BREAK_TO_SCRATCHPAD: 'playlist_add_voice_break_to_scratchpad',
  DELETE_ITEM_FROM_SAVED_ITEMS: 'playlist_delete_item_from_saved_items',
  DELETE_ITEM_FROM_SCRATCHPAD: 'playlist_delete_item_from_scratchpad',
  FIND_ONE: 'playlist_find_one',
  LOADING: 'playlist_loading',
  MOVE_ITEM_FROM_SAVED_ITEMS_TO_SCRATCHPAD:
    'playlist_move_item_from_saved_items_to_scratchpad',
  MOVE_ITEM_FROM_SCRATCHPAD_TO_SAVED_ITEMS:
    'playlist_move_item_from_scratchpad_to_saved_items',
  REARRANGE_SAVED_ITEM: 'playlist_rearrange_saved_item',
  REARRANGE_SCRATCHPAD_ITEM: 'playlist_rearrange_scratchpad_item',
  SAVING: 'playlist_saving',
  UPDATE_SCRATCHPAD_ITEM: 'playlist_update_scratchpad_item',
};
